// Imports
import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { getVarType, makeDate } from "src/lib/utils.js";


export class Input extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {
            default: null,
            value: null,
            suppressed: false
        };

        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleFieldSuppress = this.handleFieldSuppress.bind(this);
    }


    componentDidMount() {
        var this_component = this;
        var portal_context = this_component['context'];
        var user_personalisation = portal_context['user_personalisation'];
        var user_attributes = user_personalisation['attributes'];

        var attribute = this_component['props']['attr'];
        var key = attribute['key'];
        var type = attribute['type'];
        
        var value = '';
        var default_value = '';
        if (type === 'multi-select') {
            value = [];
        }

        if (user_attributes) {
            if (user_attributes.hasOwnProperty(key)) {
                if (type === 'multi-select') {

                    switch(key) {
                        case 'SRV_INDCTR':
                            var target_key = 'NSI_CDE';
                            value = this_component.getStructuredAttributes(user_attributes[key], target_key);
                            default_value = value;
                            break;
                        case 'TO_DO_LIST':
                            var target_key = 'TO_LIST_CDE';
                            value = this_component.getStructuredAttributes(user_attributes[key], target_key);
                            default_value = value;
                            break;
                        default:
                            value = [].concat(user_attributes[key]);
                            default_value = value.slice(0);
                    }

                    
                } else {
                    value = user_attributes[key];
                    default_value = value;
                }
                
            }
        }
        
        this_component.setState({
            'value': value,
            'default': default_value
        });
        
    }

    //
    // Events
    //


    handleClick(e) {
        var this_component = this;
        var key = this_component['props']['id'];
        this_component['props']['handleToggle'](key);
    }

    handleChange(e) {
        var this_component = this;
        var target = e.target;
        var value = this_component['state']['value'];
        var new_value;

        var attribute = this_component['props']['attr'];
        var type = attribute['type'];

        if (type === 'multi-select') {
            var selected_value = target.getAttribute('id').split('_')[0];
            if (value.indexOf(selected_value) > -1) {
                new_value = value.filter(function(item) {
                    return item !== selected_value;
                });
            } else {
                new_value = value;
                new_value.push(selected_value);
            }
            
        } else if (type === 'boolean')  {
            new_value = target.checked ? true : false;
        
        } else {
            new_value = target.value;
        }

        this_component.setState({
            value: new_value
        });

        this_component.updateAttribute(new_value);
    }

    handleFieldSuppress(e) {
        var this_component = this;
        var suppressed = !this_component['state']['suppressed'];
        var value = this_component['state']['value'];

        if (suppressed) {
            this_component.resetAttribute();
        } else {
            this_component.updateAttribute(value);
        }

        this_component.setState({
            suppressed: suppressed
        });
    }
    


    //
    // Functions
    //

    updateStructuredAttribute(attribute_key, attribute_value) {
        var this_component = this;
        var attribute_options = this_component['props']['attr']['options'];

        if(attribute_key === 'SRV_INDCTR') {
            var attribute_list = [];

            attribute_value.forEach(function(attr, attr_index){
                var attribute_structure = {
                    'NSI_CDE': attr,
                    'NSI_DESCR': attribute_options[attr]
                }

                attribute_list.push(attribute_structure);
            });

            return attribute_list;
        }

        if(attribute_key === 'TO_DO_LIST') {
            var attribute_list = [];

            attribute_value.forEach(function(attr, attr_index){
                var attribute_structure = {
                    'TO_LIST_CDE': attr,
                    'TO_DO_LIST_DESCR': attribute_options[attr]
                }

                attribute_list.push(attribute_structure);
            });

            return attribute_list;
        }
    }

    updateAttribute(value) {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];
        
        var user_personalisation = portal_context['user_personalisation'];
        var user_attributes = user_personalisation['attributes'];

        var attribute = this_component['props']['attr'];
        var key = attribute['key'];
        var structured_attributes = ['SRV_INDCTR', 'TO_DO_LIST'];
        
        if(structured_attributes.indexOf(attribute['key']) !== -1) {
            value = this_component.updateStructuredAttribute(attribute['key'], value);
        }

        if (user_attributes) {
            user_personalisation['attributes'][key] = value;
            helpers.updatePersonalisation(user_personalisation);
        }

    }

    resetAttribute() {
        var this_component = this;
        var attribute = this_component['props']['attr'];
        var key = attribute['key'];

        var personalisation_in_storage = squiz.fn.getStorage('userpersonalisation', 'session', 'json');
        var user_attributes = personalisation_in_storage['data']['attributes'];
        var original_val = user_attributes[key];

        this_component.updateAttribute(original_val);
    }


    renderInput() {
        var this_component = this;
        var attribute = this_component['props']['attr'];
        var type = attribute['type'];
        
        switch(type) {
            case 'text':
                return this_component.renderTextInput();
            case 'multi-select':
                return this_component.renderMultiSelect();
            case 'select':
                return this_component.renderSelect();
            case 'boolean':
                return this_component.renderBoolean();
            case 'date':
                return this_component.renderDate();
            case 'date-range':
                return this_component.renderDateRange();
        }
    }

    renderTextInput() {
        var this_component = this;
        var attribute = this_component['props']['attr'];
        var key = attribute['key'];
        var value = this_component['state']['value'] ? this_component['state']['value'] : '';
        var component_id = this['props']['id'];

        return (
            <div className="simulation-panel__dropdown__input__container">
                <label htmlFor={key + '_' + component_id} className="visuallyhidden">{attribute['name']}</label>
                <input id={key + '_' + component_id} type="text" value={value} onChange={this_component.handleChange}/>
            </div>
        );
    }

    renderSelect() {
        var this_component = this;
        var attribute = this_component['props']['attr'];
        var key = attribute['key'];
        var options = attribute['options'];
        var selected_value = this_component['state']['value'] ? this_component['state']['value'] : '';
        var component_id = this['props']['id'];

        if (options) {
            var option_list = null;
            var arr = [];
            for (var key in options) {
                if (!options.hasOwnProperty(key)) continue;

                arr.push({
                    value: key,
                    text: options[key]
                });
            }

            option_list = arr.map(function(option, key) {
                return (
                    <option key={key} value={option['value']}>{option['text']}</option>
                );
            });

            return (
                <div className="simulation-panel__dropdown__select__container">
                    <label htmlFor={key + '_' + component_id}>{attribute['name']}</label>
                    <select name={key} id={key + '_' + component_id} value={selected_value} onChange={this_component.handleChange}>
                        {option_list}
                    </select>
                </div>
            );
        }
    }

    renderMultiSelect() {
        var this_component = this;
        var attribute = this_component['props']['attr'];
        var options = attribute['options'];
        var selected = this['state']['value'] ? this['state']['value'] : [];
        var component_id = this['props']['id'];

        if (options) {
            var arr = [];

            for (var key in options) {
                if (!options.hasOwnProperty(key)) continue;

                var checked = false;
                if (selected.indexOf(key) > -1) {
                    checked = true;
                }

                arr.push({
                    value: key,
                    text: options[key],
                    checked: checked
                });
            }

            return arr.map(function(option, key) {
                return (
                    <div key={key} className="simulation-panel__dropdown__checkbox__container">
                        <input type="checkbox" name={option['value']} id={option['value'] + '_' + component_id} defaultChecked={option['checked']} onChange={this_component.handleChange} />
                        <label htmlFor={option['value'] + '_' + component_id}>{option['text']}</label>
                    </div>
                );
            });
             
        }
    }

    renderDate() {
        var this_component = this;
        var attribute = this_component['props']['attr'];
        var key = attribute['key'];
        var value = this_component['state']['value'] ? this_component['state']['value'] : '';
        var component_id = this['props']['id'];
        
        return (
            <div className="simulation-panel__dropdown__input__container">
                <label htmlFor={key + '_' + component_id} className="visuallyhidden">{attribute['name']}</label>
                <input id={key + '_' + component_id} value={value} type="date" placeholder="dd/mm/yy" onChange={this_component.handleChange} />
            </div>
        );
    }

    renderDateRange() {
        var this_component = this;
        var attribute = this_component['props']['attr'];
        var key = attribute['key'];
        var value = this_component['state']['value'] ? this_component['state']['value'] : '';
        var component_id = this['props']['id'];
        
        return (
            <div className="simulation-panel__dropdown__input__container">
                <label htmlFor={key + '_' + component_id} className="visuallyhidden">{attribute['name']}</label>
                <input id={key + '_' + component_id} value={value} type="datetime-local" placeholder="dd/mm/yyyy, hh:mm:ss" onChange={this_component.handleChange} />
            </div>
        );
    }

    renderBoolean() {
        var this_component = this;
        var attribute = this_component['props']['attr'];
        var key = attribute['key'];
        var value = this_component['state']['value'] ? this_component['state']['value'] : false;
        var component_id = this['props']['id'];

        return (
            <div className="simulation-panel__dropdown__true-false__container">
                <input type="checkbox" name={key} id={key + '_' + component_id} defaultChecked={value} onChange={this_component.handleChange} />
                <label htmlFor={key + '_' + component_id}>True</label>
            </div>
        );
    }

    getDateValue(date_string) {
        var date_format = 'DD/MM/YYYY';
        var new_date = makeDate(new Date(date_string), date_format);

        return new_date;
    }

    getStructuredAttributes(attribute_data, target_key) {
        var value_type = getVarType(attribute_data);
        var value_list = [];

        if(value_type === 'array') {
            attribute_data.forEach(function(item, item_index) {
                var item_value = item[target_key];
                value_list.push(item_value);
            });
        } else {
            Object.keys(attribute_data).forEach(function(item, item_index) {
                if(item === target_key) {
                    var item_value = attribute_data[item];
                    value_list.push(item_value);
                }
            });
        }

        return value_list;
    }

    getFriendlyValue() {
        var this_component = this;
        var value = this_component['state']['value'];
        var value_key = this_component['props']['attr']['key'];
        var value_type = this_component['props']['attr']['type'];
        var value_options = this_component['props']['attr']['options'];

        if (this_component['state']['suppressed']) {
            value = this_component['state']['default'];
        }

        if(value_key === 'SRV_INDCTR') {
            //return this_component.getServiceIndicators(value);
        }

        if(value_key === 'TO_DO_LIST') {
            
        }

        if(value_type === 'date' || value_type === 'date-range') {
            if(value !== '') {
                return this_component.getDateValue(value);
            }
        }

        if (Array.isArray(value)) {
            if (value.length > 0) {
                return value.join(', ');
            }
        }
       
        return value;

    }


    //
    // Render
    //

    render() {
        var this_component = this;
        var attribute = this_component['props']['attr'];
        var id = this_component['props']['id'];

        if (attribute && this_component['state']['value'] !== null) {

            var example = null;
            if (attribute['example']) {
                example = (
                    <div className="simulation-panel__dropdown__example">
                        <i>E.g:</i> {attribute['example']}
                    </div>
                );
            }

            var note = null;
            if (attribute['note']) {
                note = (
                    <div className="simulation-panel__dropdown__note">
                        Note: {attribute['note']}
                    </div>
                );
            }
            
            var is_active = this_component['props']['active'];
            var active_class = is_active ? ' open' : '';

            return (
                <li className="simulation-panel__dropdown__container js_dropdown_section">
                    
                    <button className={"simulation-panel__dropdown--toggle" + active_class} onClick={this_component.handleClick}>
                        {attribute['name']}
                    </button>

                    <span className="simulation-panel__attribute">
                        {this_component.getFriendlyValue()}
                    </span>
                    
                    <div className={"simulation-panel__dropdown--section" + active_class}>
                        
                        {example}
                        {note}
                        {this_component.renderInput(attribute)}

                        <div className="simulation-panel__dropdown__suppress-field">
                            <input type="checkbox" name="suppress-field" id={"suppress-field-" + id}  onChange={this_component.handleFieldSuppress} defaultChecked={this_component['state']['suppressed']} />
                            <label htmlFor={"suppress-field-" + id}>Suppress this field (simulation not set)</label>
                        </div>

                    </div>
                </li> 
            );
        }
        
        return null;
    }

};

Input.contextType = PortalContext;

